let environment = "PRODUCTION";
let appUrl = `//${document.location.host}/`;
if (appUrl.endsWith(":3000/")) {
  appUrl = "//sxs-api.ddev.site/";
  environment = "DEVELOPER";
} else if (document.location.href.indexOf("/candidatura") !== -1) {
  appUrl = `//${appUrl}candidatura/`;
}

export const APP_URL = appUrl;
export const API_URL = `${APP_URL}api`;
export const SIGNUP_URL = `${APP_URL}signup/`;
export const VERSION = "1.0.{BITBUCKET_BUILD_NUMBER}";
export const DRAWER_WIDTH = 260;
export const APP_TITLE = "Strada per strada";
export const ENVIRONMENT = environment;
export const MAX_FILE_SIZE = 100000000; // 20 MB
export const ACCEPTED_FILE_MEDIA_TYPES = [
  ".gif",
  ".png",
  ".jpg",
  ".jpeg",
  ".bmp",
];

export const ACCEPTED_FILE_TYPES = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".zip",
  ".p7m",
].concat(ACCEPTED_FILE_MEDIA_TYPES);

let recaptchaSiteKey = "";

switch (appUrl) {
  case "//stradaperstrada.regione.puglia.it/candidatura/":
    recaptchaSiteKey = "6LclGXkcAAAAAORw_xa9r1a1qJ4Nnsba8AhLuNZ_";
    break;
  case "//sxs-api.ddev.site/":
  default:
    recaptchaSiteKey = "6LekNssfAAAAABcnZL0o-OmJPRUc52L8lxYz_dex";
    break;
}

export const RECAPTCHA_SITE_KEY = recaptchaSiteKey;
